import { render } from "./HomeGameList.vue?vue&type=template&id=63dc035c&scoped=true"
import script from "./HomeGameList.vue?vue&type=script&lang=js"
export * from "./HomeGameList.vue?vue&type=script&lang=js"

import "./HomeGameList.vue?vue&type=style&index=0&id=63dc035c&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dc035c"]])

export default __exports__